import { connect } from 'react-redux';

import BrandValuesModule from 'components/BrandValuesModule';
import * as actions from 'state/actions';
import Theme from 'styles/theme';
import Settings, { PAGE_TEMPLATES } from 'utils/Settings';

const mapping = {
  [PAGE_TEMPLATES.HOME]: 'backgroundColorHomepage',
  [PAGE_TEMPLATES.PLP]: 'backgroundColorPLP',
  [PAGE_TEMPLATES.CUSTOM_PLP]: 'backgroundColorCustomPLP',
  [PAGE_TEMPLATES.PDP]: 'backgroundColorPDP',
};

const mapStateToProps = () => {
  const content = Settings.brandValues || {};
  const showModule = content.enabled;

  const { heading, items } = content;
  const backgroundColor = content[mapping[Settings.page]] ?? Theme.get('colors-white');
  return {
    backgroundColor,
    items,
    heading,
    showModule,
  };
};

const mapDispatchToProps = dispatch => ({
  trackLinkClick: payload => {
    dispatch(
      actions.trackEngagementClick({
        eventCategory: 'Global',
        eventAction: 'brandValueModuleLinkClick',
        eventLabel: payload,
      })
    );

    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandValuesModule);
